import React, { HTMLProps } from 'react';

import Props from './SocialButtonsInterface';
import { GoogleIcon, SocialButton } from './styles';

export function GoogleForm({
  id = 'google_form',
  xsrft,
  action,
  children,
  optIn,
  turnstileToken,
  redirectUrl,
  onClick,
  onSubmit,
  redirectUrlAfterSocialLogin,
  socialSubmitBtn,
  target = '_self',
  source,
  className,
}: Props) {
  const url = action === 'join' ? '/join' : '/log_in';

  const formProps: HTMLProps<HTMLFormElement> = {
    id,
    method: 'POST',
    action: url,
    noValidate: true,
    onSubmit: onSubmit,
    target: target,
  };

  if (target === '_blank') {
    formProps.rel = 'opener';
  }

  return (
    <form {...formProps}>
      <input type="hidden" name="service" value="google" />
      <input type="hidden" name="action" value={action} />
      <input type="hidden" name="token" value={xsrft} />
      {redirectUrl && redirectUrl !== 'undefined' && (
        <input type="hidden" name="redirect" value={redirectUrl} />
      )}
      {redirectUrlAfterSocialLogin && redirectUrlAfterSocialLogin !== 'undefined' && (
        <input
          type="hidden"
          name="redirect_url_after_social_login"
          value={redirectUrlAfterSocialLogin}
        />
      )}
      {optIn !== null && <input type="hidden" name="marketing_opt_in" value={`${optIn}`} />}
      {turnstileToken !== null && (
        <input type="hidden" name="cf-turnstile-response" value={`${turnstileToken}`} />
      )}
      {source && <input type="hidden" name="source" value={source} />}
      {socialSubmitBtn || (
        <SocialButton
          className={className}
          icon={<GoogleIcon />}
          format="secondary"
          onClick={() => onClick?.()}
        >
          {children}
        </SocialButton>
      )}
    </form>
  );
}
